import classNames from "classnames";
import { Button } from "PFComponents/button";
import { useForm } from "react-hook-form";

import { BookingNoteInput } from "../booking_note_form";
import { BookingNoteInputs } from "../types";
import css from "./booking_note_form.module.scss";

type BookingNoteFormProps = {
  defaultValues?: BookingNoteInputs;
  onSubmit: (props: { data: BookingNoteInputs; onSuccess?: () => void }) => void;
  classes?: Record<string, string>;
  disabled: boolean;
  submitLabel: string;
  placeholder?: string;
};

const DEFAULT_VALUES: BookingNoteInputs = { content: "" };

export const BookingNoteForm = ({
  defaultValues = DEFAULT_VALUES,
  onSubmit,
  classes = {},
  disabled,
  submitLabel,
  placeholder
}: BookingNoteFormProps) => {
  const {
    handleSubmit,
    control,
    setValue,
    formState: { isValid, isDirty }
  } = useForm<BookingNoteInputs>({
    mode: "onChange",
    defaultValues
  });

  const clearContent = () =>
    setValue("content", "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });

  const onFormSubmit = (data: BookingNoteInputs) => {
    onSubmit({ data, onSuccess: clearContent });
  };

  return (
    <form onSubmit={handleSubmit(onFormSubmit)}>
      <div className={classNames(css.root, classes.root)}>
        <BookingNoteInput control={control} disabled={disabled} placeholder={placeholder} />
        <Button text={submitLabel} type="submit" disabled={!isDirty || !isValid || disabled} />
      </div>
    </form>
  );
};
